import { defineStore, acceptHMRUpdate } from 'pinia'
import type { Category, Product, ProductAPIResponse } from '~/utils/products'

export const useProductsStore = defineStore('products', () => {
  const products = ref<Product[]>([])
  const categories = ref<Category[]>([])

  const fetchProducts = async () => {
    const { data } = await $apiFetch<ProductAPIResponse>(`products`, '/api/products')
    products.value = data.value!.products
    categories.value = data.value!.categories
  }

  return { categories, products, fetchProducts }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useProductsStore, import.meta.hot))
}
